export default "__VITE_ASSET__JjtemDVB__"